import * as React from "react";

import { LtnDto } from "core/backend/data";
import { MultiSelectItem } from "components/multiselect";
import TDatetime from "components/TDatetime";

interface OwnProps {
    dto: LtnDto;
    borders: MultiSelectItem[];
    left: number;
}

const Row = ({ dto, borders, left }: OwnProps) =>
    <tr>
        <TDatetime rowSpan={1} date={new Date(dto.dateTimeUtc)} left={left} />
        {borders.map((border) => <td key={border.id}>{eval("dto.border_" + border.id.toUpperCase())}</td>)}
    </tr>;

export default Row;